import React from 'react';
import { motion } from 'framer-motion';
import './PageTransition.css';

const pageVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            duration: 0.6,
            ease: 'easeOut',
            staggerChildren: 0.08,
        }
    }
};

const childVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.5,
            ease: [0.25, 0.46, 0.45, 0.94]
        }
    }
};

const PageTransition = ({ children, show }) => {
    if (!show) return null;

    return (
        <motion.div
            className="page-transition-wrapper"
            variants={pageVariants}
            initial="hidden"
            animate="visible"
        >
            {React.Children.map(children, (child) => (
                <motion.div variants={childVariants}>
                    {child}
                </motion.div>
            ))}
        </motion.div>
    );
};

export default PageTransition;
